/**
 * v0.4 追加要件⑪ (D-372): シフトレポート系画面 (`/shift/report/daily`・全社調整の日別マトリクス) が
 * 共有する null_reason の表示語彙。バックエンドはコードのみを返す方針 (D-372) のため、フロント側の
 * 語彙を1箇所に集約する (2画面で個別定義すると §8-55 型の食い違いが起きる)。
 */
export type NullReason =
  | 'no_permission' | 'visibility_rule' | 'granularity_monthly' | 'undeterminable'
  | 'not_implemented' | 'not_configured' | 'no_data';

export const NULL_REASON_LABELS: Record<NullReason, string> = {
  no_permission: '非公開', visibility_rule: '非公開', granularity_monthly: '月次のみ',
  undeterminable: '判定不能', not_implemented: '集計対象外', not_configured: '未設定', no_data: '—',
};

// §4-4[4]: omitted_metrics の reason は null_reasons と語彙が微妙に異なる (feature_disabled を含む)
// v0.4 章⑦フォローアップ (D-348、design-and-code MEDIUM指摘): report_views の RenderedColumn.omitted_reason
// (常に 'metric_unavailable' の1値、権限/月次粒度/削除済み式/不正な式のいずれもこの1コードに集約) が
// 未登録だったため、Daily画面のtitleツールチップが生コードをそのまま表示していた。
export const OMITTED_REASON_LABELS: Record<string, string> = { ...NULL_REASON_LABELS, feature_disabled: '機能未有効化', metric_unavailable: '権限または設定により非表示' };

/**
 * v0.4 追加要件⑮ (D-573): 人件費の確度トグル (`/shift/report/daily`・`/employees`・編成ボード が
 * 共有)。既存の `estimate`/`provisional` の計算は一切変えず (§4b-4)、'actual' (確定した実績のみ、
 * 予定へのフォールバックをしない) を新設した第三の値として追加した。
 * ⚠️ `provisional` は「実績があれば実績、無ければ予定で埋める」= compliance ドメイン
 * (`/shift/report/compliance`) の 'forecast' と数学的に同一の計算のため、UI ラベルは
 * 「実績反映後」ではなく「見込み」とする方が実態を正しく表す (D-535 と表現を揃える)。
 */
export type LaborCostConfidence = 'estimate' | 'actual' | 'provisional';

export const LABOR_COST_CONFIDENCE_OPTIONS: ReadonlyArray<{ value: LaborCostConfidence; label: string }> = [
  { value: 'estimate', label: '予定' },
  { value: 'actual', label: '実績' },
  { value: 'provisional', label: '見込み' },
];

export const LABOR_COST_CONFIDENCE_LABELS: Record<LaborCostConfidence, string> = {
  estimate: '予定', actual: '実績', provisional: '見込み',
};
